import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { PmsService } from 'app/shared/services/pms/pms.service';
import { JwtAuthService } from 'app/shared/services/auth/jwt-auth.service';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.template.html',
})
export class SidenavComponent {
  @Input('items') public menuItems: any[] = [];
  @Input('hasIconMenu') public hasIconTypeMenuItem: boolean;
  @Input('iconMenuTitle') public iconTypeMenuTitle: string;
  @ViewChild('sidenav') sidenav: ElementRef;
  private dataSubscription: Subscription;
  productId;
  current_route;
  userType: string;
  tourCode: any;

  constructor(
    private api: PmsService,
    private router: Router,
    private jwt: JwtAuthService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.current_route = this.router.url.split('/')[1];
        this.restoreProductIdFromUrl();
      }
    });
  }

  ngOnInit() {
    this.current_route = this.router.url.split('/')[1];
    this.restoreProductIdFromUrl();
    this.dataSubscription = this.api.productId$.subscribe((data) => {
      this.productId = data;
    });
    this.dataSubscription = this.api.productId$.subscribe((data) => {
      this.productId = data;
    });
    this.dataSubscription = this.jwt.permissions$.subscribe((data) => {
      this.userType = data.user_type;

      if (['supplier', 'merchant'].includes(this.userType)) {
        const hiddenItems = [
          "Booking Enquiries",
          "Contact Leads",
          "Transfers Bookings",
          "Customers",
          "Customer Groups",
          "Club Pass",
          "Coupons",
          "Attraction Pass",
          "Affiliates",
          "Grievances"
        ];
        if (this.userType === 'merchant') {
          hiddenItems.push("Voucher Portal");

          if (this.current_route === 'pms') {
            hiddenItems.push("Tour Details", "Up-Sell", "Cross-Sell", "Reviews & Ratings", "Categories", "Tickets & Pricing");
          }
        }

        this.menuItems = this.menuItems.filter(item => !hiddenItems.includes(item.name));
      }
    });

    // if (this.productId) {
    //   this.getTourDetails();
    // }
    // this.api.currentResult.subscribe((data) => {
    //   this.tourCode = data?.tour_code;
    // });
  }
  
  ngAfterViewInit() {
    setTimeout(() => {
      const links = this.sidenav.nativeElement.querySelectorAll(
        'li[appdropdownlink]'
      );
      [...links].forEach((link) => {
        if (link.querySelector('a.open')) {
          link.classList.add('open');
        }
      });
    });
  }

  ngOnDestroy() {
    this.dataSubscription.unsubscribe();
  }

  // getTourDetails() {
  //   this.api.getTourDetails(this.productId).subscribe((result) => {
  //     this.tourCode = result?.tour_code;
  //   });
  // }

  private restoreProductIdFromUrl(): void {
    const path = this.router.url.split('?')[0];
    const segments = path.split('/').filter(Boolean);
    const productRoutes = new Set([
      'add-product',
      'tour-details',
      'pricing',
      'categories',
      'upsell-product',
      'crosssell-product',
      'reviews-ratings',
      'booking-questions',
      'cancellation-policy'
    ]);

    if (
      segments[0] === 'pms' &&
      productRoutes.has(segments[1]) &&
      segments[2]
    ) {
      const productId = decodeURIComponent(segments[2]);
      this.productId = productId;
      this.api.updateProductId(productId);
    }
  }
}
